import type { RoleSummaryProps } from "./types-role-summary";
import { RoleSummaryView } from "./view-role-summary";

/** Bloco somente leitura com os dados do perfil, compartilhado pelos dois pop-ups da exclusão; sem lógica. */
export function RoleSummary(props: RoleSummaryProps) {
  return <RoleSummaryView {...props} />;
}

export type * from "./types-role-summary";
